import React from 'react';
import { Search, ShoppingCart, Truck } from 'lucide-react';

const WhyChooseUs = () => {
  const steps = [
    {
      number: 1,
      title: 'Browse',
      description: 'Browse our categories and find what your animals need',
      icon: Search,
    },
    {
      number: 2,
      title: 'Order',
      description: 'Online, by phone, or text message \u2014 quick and simple',
      icon: ShoppingCart,
    },
    {
      number: 3,
      title: 'Receive',
      description: 'Get it delivered to a drop-off location or pick up \u2014 close to home, without the hassle',
      icon: Truck,
    },
  ];

  return (
    <section className="py-24 bg-[#FAF6F0] relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%232D5016' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }} />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-3 py-1 rounded-full bg-[#2D5016]/10 text-[#2D5016] text-xs font-semibold uppercase tracking-wider mb-4">
            Our Process
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-[#3B2F1E] mb-6">
            Why Choose Good Grains?
          </h2>
          <p className="text-[#3B2F1E]/70 text-lg max-w-2xl mx-auto mb-4">
            At Good Grains, we're more than just a feed supplier \u2014 we're part of your farming and homesteading community
          </p>
          <p className="text-[#3B2F1E]/60 max-w-3xl mx-auto leading-relaxed">
            Here at Good Grains, we're working to make your life more convenient, with flexible hours for easy pick-up at our location or delivery drop-off locations nearby. Whether you need a few 50 lb bags for your backyard flock or a full tote for a larger farm, we've got you covered. From bulk to ground shipments, getting fresh, high-quality feed has never been easier or fresher.
          </p>
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Connecting Line */}
          <div className="hidden md:block absolute top-20 left-1/4 right-1/4 h-1 bg-gradient-to-r from-[#D4A84B] via-[#2D5016] to-[#D4A84B]" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {steps.map((step, index) => (
              <div
                key={step.number}
                className="relative text-center group"
                style={{ animationDelay: `${index * 200}ms` }}
              >
                {/* Number Circle */}
                <div className="relative inline-flex items-center justify-center mb-6">
                  <div className="w-24 h-24 rounded-full bg-white shadow-xl flex items-center justify-center group-hover:shadow-2xl transition-shadow duration-300 relative z-10">
                    <step.icon className="w-10 h-10 text-[#2D5016]" />
                  </div>
                  <div className="absolute -top-2 -right-2 w-10 h-10 rounded-full bg-[#D4A84B] flex items-center justify-center text-white font-bold text-lg shadow-lg">
                    {step.number}
                  </div>
                </div>

                {/* Content */}
                <h3 className="font-serif text-2xl font-bold text-[#3B2F1E] mb-3">
                  {step.title}
                </h3>
                <p className="text-[#3B2F1E]/70 leading-relaxed max-w-xs mx-auto">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
